'use client'

import { useCallback } from 'react'
import { usePathname } from 'next/navigation'

export const useThanksForAppRouter = () => {
  const pathname = usePathname()

  const pushThanks = useCallback(
    /** from を渡すと送信元のパスではなく、その値で固定する（hook.tsx の createThanksPath と同じ形） */
    (to: string, from?: string) => {
      const currentPath = pathname || '/'
      const path = currentPath.split('/').filter(Boolean)
      const fromPath = path.length > 0 ? path.join('-') : 'home'
      const newUrl = `/${to}/?from=${from ?? fromPath}`

      window.location.href = newUrl
    },
    [pathname]
  )

  return { pushThanks }
}
